import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Guarantee() {
  return <section className="w-full bg-cream px-4 py-14" data-id="element-112" data-mp="1o2vjmvsbez9q">
      <div className="mx-auto max-w-2xl" data-id="element-113" data-mp="22367dpybvxqo">
        <div className="rounded-3xl border-2 border-green-200 bg-white p-6 text-center shadow-sm sm:p-8" data-id="element-114" data-mp="2223g3gx3fta8">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-green-50" data-id="element-115" data-mp="1x4uybhfuxr9i">
            <ShieldCheckIcon className="h-8 w-8 text-green-600" aria-hidden="true" data-id="element-116" data-mp="19f0o77mxagsy" />
          </div>
          <p className="mt-4 text-[12px] font-extrabold uppercase tracking-widest text-green-700" data-id="element-117" data-mp="14hhaq9y1u822">
            Tu compra está protegida
          </p>
          <h2 className="mt-2 font-display text-[24px] font-bold leading-tight text-navy-900 sm:text-3xl" data-id="element-118" data-mp="1edbvpbpqwf80">
            Garantía de satisfacción de 7 días
          </h2>
          <p className="mt-4 text-[14px] leading-relaxed text-navy/70 sm:text-[15px]" data-id="element-119" data-mp="qlws7fm8frv6">
            Sabemos que este material puede transformar la forma en la que abordas a tus pacientes con
            obesidad. Por eso puedes revisarlo durante los próximos 7 días.
          </p>
          <p className="mt-3 text-[14px] leading-relaxed text-navy/70 sm:text-[15px]" data-id="element-120" data-mp="twrxyws3c0w7">
            Si consideras que el Kit no te ayuda a tomar decisiones más rápidas, no aporta valor a tu
            práctica clínica o simplemente no cumple tus expectativas, solo escríbenos y te
            devolveremos el 100% de tu dinero.
          </p>
          <p className="mt-4 text-[14px] font-semibold text-navy" data-id="element-121" data-mp="azh0nhq0rhje">
            Sin preguntas. Sin complicaciones. Sin riesgos para ti.
          </p>
        </div>

        <div className="mt-8 flex justify-center" data-id="element-122" data-mp="f3gajhgsni3s">
          <CTAButton label="PROBARLO SIN RIESGO HOY" sublabel="7 días de garantía · Devolución del 100%" pulse={false} data-id="element-123" data-mp="k0ou9mhlbu75" />
        </div>
      </div>
    </section>;
}